// Auto-generated file created by SVGR source illustrationTemplate.ts
// DO NOT EDIT THIE FILE
import { SVGUniqueID } from './svg-unique-id';
import type { IllustrationProps } from './types';
const Illustration = (props: IllustrationProps) => (
  <svg
    width={152}
    height={97}
    viewBox="0 0 152 97"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 0H152V96.8213H0V0Z"
      fill="#EDF9FF"
    />
    <path
      d="M94.7217 42.8234H61.031V41.0565C61.031 40.5879 61.2398 40.1384 61.6115 39.8071C61.9831 39.4757 62.4872 39.2896 63.0128 39.2896H92.7399C93.2655 39.2896 93.7696 39.4757 94.1413 39.8071C94.5129 40.1384 94.7217 40.5879 94.7217 41.0565V42.8234Z"
      fill="#29A9FF"
      stroke="#29292F"
      strokeWidth={0.857143}
      strokeLinejoin="round"
    />
    <path
      d="M92.7399 63.1436H63.0128C62.4872 63.1436 61.9831 62.9574 61.6115 62.6261C61.2398 62.2947 61.031 61.8453 61.031 61.3766V42.8237H94.7217V61.3766C94.7217 61.8453 94.5129 62.2947 94.1413 62.6261C93.7696 62.9574 93.2655 63.1436 92.7399 63.1436Z"
      fill="white"
      stroke="#29292F"
      strokeWidth={0.857143}
      strokeLinejoin="round"
    />
    <path
      d="M88.7773 41.9403C89.3245 41.9403 89.7682 41.5447 89.7682 41.0568C89.7682 40.5689 89.3245 40.1733 88.7773 40.1733C88.23 40.1733 87.7864 40.5689 87.7864 41.0568C87.7864 41.5447 88.23 41.9403 88.7773 41.9403Z"
      fill="#29292F"
    />
    <path
      d="M91.746 41.9403C92.2933 41.9403 92.7369 41.5447 92.7369 41.0568C92.7369 40.5689 92.2933 40.1733 91.746 40.1733C91.1988 40.1733 90.7551 40.5689 90.7551 41.0568C90.7551 41.5447 91.1988 41.9403 91.746 41.9403Z"
      fill="#29292F"
    />
    <path
      d="M52.4125 31.0554L52.7527 31.0653C54.1169 31.1069 55.4055 31.5974 56.335 32.4288C57.2644 33.2603 57.7587 34.3647 57.7091 35.4991L57.6955 35.782L57.7091 35.4991C57.7336 34.9374 57.8911 34.3851 58.1723 33.8739C58.4536 33.3628 58.8533 32.9027 59.3485 32.52C59.8436 32.1373 60.4246 31.8394 61.0583 31.6434C61.6919 31.4475 62.3658 31.3572 63.0414 31.3778L63.3815 31.3892L63.0414 31.3778C62.3658 31.3574 61.7016 31.2265 61.0869 30.9926C60.4721 30.7587 59.9188 30.4264 59.4585 30.0147C58.9983 29.6029 58.6401 29.1198 58.4044 28.5929C58.1687 28.0661 58.0602 27.5058 58.085 26.944L58.0969 26.6611L58.085 26.944C58.0604 27.5058 57.903 28.058 57.6217 28.5692C57.3404 29.0803 56.9407 29.5404 56.4456 29.9231C55.9504 30.3059 55.3694 30.6037 54.7357 30.7997C54.1021 30.9956 53.4282 31.0859 52.7527 31.0653L52.4125 31.0554Z"
      fill="white"
      stroke="#29292F"
      strokeMiterlimit={10}
      strokeLinejoin="round"
    />
    <path
      d="M48.7379 41.6374C49.7124 41.6662 50.6328 42.0058 51.2967 42.5814C51.9606 43.157 52.3136 43.9216 52.2782 44.707C52.2957 44.3181 52.4081 43.9357 52.6091 43.5819C52.81 43.228 53.0955 42.9095 53.4491 42.6445C53.8028 42.3795 54.2178 42.1733 54.6704 42.0377C55.123 41.902 55.6044 41.8395 56.0869 41.8538C55.6044 41.8396 55.13 41.749 54.6909 41.5871C54.2518 41.4252 53.8565 41.1951 53.5278 40.9101C53.199 40.625 52.9432 40.2905 52.7748 39.9258C52.6065 39.561 52.5289 39.1731 52.5467 38.7842C52.5291 39.1731 52.4167 39.5554 52.2157 39.9093C52.0148 40.2632 51.7293 40.5817 51.3756 40.8467C51.022 41.1116 50.607 41.3179 50.1544 41.4535C49.7018 41.5892 49.2204 41.6517 48.7379 41.6374Z"
      fill="white"
    />
    <path
      d="M48.4949 41.6305L48.7379 41.6374M48.7379 41.6374C49.7124 41.6662 50.6328 42.0058 51.2967 42.5814C51.9606 43.157 52.3136 43.9216 52.2782 44.707M48.7379 41.6374C49.2204 41.6517 49.7018 41.5892 50.1544 41.4535C50.607 41.3179 51.022 41.1116 51.3756 40.8467C51.7293 40.5817 52.0148 40.2632 52.2157 39.9093C52.4167 39.5554 52.5291 39.1731 52.5467 38.7842M52.2782 44.707L52.2684 44.9028M52.2782 44.707C52.2957 44.3181 52.4081 43.9357 52.6091 43.5819C52.81 43.228 53.0955 42.9095 53.4491 42.6445C53.8028 42.3795 54.2178 42.1733 54.6704 42.0377C55.123 41.902 55.6044 41.8395 56.0869 41.8538M56.0869 41.8538L56.3299 41.8616M56.0869 41.8538C55.6044 41.8396 55.13 41.749 54.6909 41.5871C54.2518 41.4252 53.8565 41.1951 53.5278 40.9101C53.199 40.625 52.9432 40.2905 52.7748 39.9258C52.6065 39.561 52.5289 39.1731 52.5467 38.7842M52.5467 38.7842L52.5552 38.5884"
      stroke="#29292F"
      strokeWidth={0.9}
      strokeMiterlimit={10}
      strokeLinejoin="round"
    />
    <path
      d="M84.4185 53C84.4185 56.3138 81.7322 59 78.4185 59C75.1047 59 72.4185 56.3138 72.4185 53C72.4185 49.6862 75.1047 47 78.4185 47C81.7322 47 84.4185 49.6862 84.4185 53Z"
      stroke="#37363F"
      strokeWidth={0.8}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M81.1113 53C81.1113 56.3138 79.9055 59 78.4183 59C76.9309 59 75.7251 56.3138 75.7251 53C75.7251 49.6862 76.9309 47 78.4183 47C79.9057 47 81.1113 49.6862 81.1113 53Z"
      stroke="#37363F"
      strokeWidth={0.8}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M83.5604 49.9087H73.2754"
      stroke="#37363F"
      strokeWidth={0.8}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M84.4181 53.001H72.4181"
      stroke="#37363F"
      strokeWidth={0.8}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M83.5604 56.0908H73.2754"
      stroke="#37363F"
      strokeWidth={0.8}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const SvgUrlPlaceholder = (props: IllustrationProps) => (
  <SVGUniqueID>{Illustration(props)}</SVGUniqueID>
);
export default SvgUrlPlaceholder;
